import * as React from 'react'
import { ActivityTypeItem } from './ActivityTypeItem'
import Stack from '@mui/material/Stack'
import { ActivityTypesListHeader } from './ActivityTypesListHeader'
import { useData, useHandlers } from './hooks'
import {
  DeleteConfirmationPopup,
  LoadingSpinner,
} from '@sales-center/components'
import { EmptyStub } from './EmptyStub'

export function ActivityTypesList() {
  const { activityTypes, isEmptyList, loading, deleteDialogOpened } = useData()
  const { handleCancelClick, handleDeleteClick } = useHandlers()

  return (
    <Stack>
      {loading ? (
        <LoadingSpinner />
      ) : isEmptyList ? (
        <EmptyStub />
      ) : (
        <>
          <ActivityTypesListHeader activityTypes={activityTypes} />
          {activityTypes.map((activityType, index) => (
            <ActivityTypeItem
              activityType={activityType}
              key={`activity_type_${index}`}
            />
          ))}
        </>
      )}

      <DeleteConfirmationPopup
        onCancelClick={handleCancelClick}
        onDeleteClick={handleDeleteClick}
        open={deleteDialogOpened}
        description="Deleting this activity will remove it from all records.  Are you sure you want to do this?"
      />
    </Stack>
  )
}
